import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './product.action';
import { Product } from './product.model';

export interface ProductRecordsState {
    listData: Product;
    loading: boolean;
    error: any;
}

export const initialState: ProductRecordsState = {
    listData: null,
    loading: false,
    error: null,
};


export const ProductsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData }) => {
        return { ...state, listData: listData, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
);